import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Individual/Profile';
const moduleAjaxService = 'AMS'

const api = {
    namespaced: true,
    state: {
        list: {},
        dropDownList: []
    },
    actions: {
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    // Clear the dropdown cache so it will reload fresh data
                    context.commit('CLEAR_DROPDOWN_CACHE')
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },

        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    // Clear the dropdown cache so it will reload fresh data
                    context.commit('CLEAR_DROPDOWN_CACHE')
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },

        async get(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                })
            })
        },

        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    // Clear the dropdown cache so it will reload fresh data
                    context.commit('CLEAR_DROPDOWN_CACHE')
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },

        async list(context, params) {
            let page = (params.page) ? params.page : 1
            let search = (params.hasOwnProperty('search')) ? "&search=" + encodeURIComponent(params.search) : ''
            
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search,
                data: null
            }

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data)
                }).catch(e => {
                    reject(e)
                })
            })
        },

        async dropDownList(context, params) {
            if (context.state.dropDownList.length > 0) {
                return context.state.dropDownList
            }

            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list',
                data: null
            }

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    // Handle simple array response
                    let data = Array.isArray(r) ? r : (r.data || [])
                    context.commit('SET_DROPDOWN_LIST', data)
                    resolve(data)
                }).catch(e => {
                    reject(e)
                })
            })
        }
    },
    mutations: {
        SET_DROPDOWN_LIST(state, data) {
            state.dropDownList = data
        },
        CLEAR_DROPDOWN_CACHE(state) {
            state.dropDownList = []
        }
    }
}

export default api